
import { defineComponent, computed, ref } from 'vue';

import model_trainers from "@/model_trainers";

import useConfig from '@/composables/useConfig'
const config = useConfig()

export default defineComponent({

	setup() {

		const page_next_disabled = computed( () => config.dataset.file == null && config.model.file == null )
		
		return {
			
			config,
			model_trainers,

			page_next_disabled,

		}

	},

});
